module.exports = "Group ID,Farm Name,Creation Date\ngroup 1,farm 1,1/31/2018\n"